export const FULL_TRAY = 70;
export const BLISTER_CATEGORIES = new Set(["macaron", "macaron_seasonal"]);

export const blisterLabel = (stock) =>
  `${Math.floor((stock || 0) / FULL_TRAY)} full · ${(stock || 0) % FULL_TRAY} partial`;


const INDIVIDUAL = new Set(["gelato_pint", "gelato_pop", "doggy_macaron", "gelato_pan"]);
export const isIndividual = (item) =>
  INDIVIDUAL.has(item.category) || /^baking kits/i.test(item.name || "");

// Inventory is always counted per single unit; cases only apply when ordering.
export const unitText = (item) => {
  if (isIndividual(item)) {
    const pack = item.deduction_qty > 1 ? ` · ordered by ${item.unit}` : "";
    return `each${pack}`;
  }
  return item.pack_size ? `${item.pack_size} / ${item.unit}` : item.unit;
};

// Activity display only: macarons as full 70-count boxes + remainder (210 → "3 full", 245 → "3 full + 35").
export const boxQty = (n, category) => {
  if (!BLISTER_CATEGORIES.has(category) || n == null) return n;
  const a = Math.abs(n), full = Math.floor(a / FULL_TRAY), rem = a % FULL_TRAY;
  const txt = full ? `${full} full${rem ? ` + ${rem}` : ""}` : `${rem}`;
  return n < 0 ? (full && rem ? `−(${txt})` : `-${txt}`) : txt;
};
